import type {
	StructuredAddress,
	UnstructuredAddress,
} from '@api/hooks/types/createTransaction.ts';
import { AddressMode, resolveAddressMode } from '@pages/payments/utils/addressUtils.ts';
import type { FieldValues, UseFormSetValue } from 'react-hook-form';

import type { BicValidationResult } from './bicApi.ts';

const buildAddress = (
	address?: StructuredAddress,
	forcedType?: AddressMode,
): StructuredAddress | UnstructuredAddress => ({
	street_name: address?.street_name ?? '',
	country: address?.country ?? '',
	town: address?.town ?? '',
	postal_code: address?.postal_code ?? '',
	building_number: address?.building_number ?? '',
	country_sub_division: address?.country_sub_division ?? '',
	building_name: address?.building_name ?? '',
	type: forcedType ?? resolveAddressMode(address),
	line: address?.line ?? '',
});

export const setBicPopulatedFields = (
	setValue: UseFormSetValue<FieldValues>,
	prefix: string,
	data?: BicValidationResult,
	forcedAddressType?: AddressMode,
) => {
	const hasData = !!data;
	const options = { shouldValidate: hasData, shouldDirty: true };

	setValue(`${prefix}.name`, data?.name ?? '', options);
	setValue(`${prefix}.address`, buildAddress(data?.address, forcedAddressType), options);
};
